// useAccessCode.ts
import { useEffect, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { setAccessCode, resetAccessForm, verifyAccessCodeAsync } from '../../../redux/flows/auth/access/index'
import { useAppDispatch, useAppSelector } from '../../../redux/store'
import { APIStatus } from '../../../redux/types'

export function useAccessCode() {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const { code, verifyAccessCodeStatus, verifyAccessCodeError } = useAppSelector((state) => state.accessAuth)

  // A previous rejection must not greet the doctor on a fresh visit.
  useEffect(() => {
    dispatch(resetAccessForm())
  }, [dispatch])

  const verifyCode = async () => {
    if (!code.trim()) return
    if (verifyAccessCodeStatus === APIStatus.pending) return

    const result = await dispatch(verifyAccessCodeAsync({ code: code.trim() }) as any)

    if (verifyAccessCodeAsync.fulfilled.match(result)) {
      navigate('/doctor-login')
    }
  }

  const verifying = useMemo(() => verifyAccessCodeStatus === APIStatus.pending, [verifyAccessCodeStatus])

  return {
    // UI state
    code,
    codeError: verifyAccessCodeError || '',
    verifying,

    // API status
    verifyAccessCodeStatus,

    // Actions
    setCode: (v: string) => dispatch(setAccessCode(v)),
    verifyCode,
    navigate,
  }
}
